import moment from 'moment';

export default ({ registration_closes_on: rco }) => moment(rco).isBefore(moment());
